export const toPersianDigits = (value) => {
  if (value == null) return '';
  const str = String(value);
  const persianDigits = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
  return str.replace(/[0-9]/g, (match) => persianDigits[parseInt(match)]);
};